const trustPolicy = `{
	"Version": "2012-10-17",
	"Statement": [
		{
			"Effect": "Allow",
			"Principal": {
				"AWS": "arn:aws:iam::324880187172:root"
			},
			"Action": "sts:AssumeRole",
			"Condition": {
				"StringLike": {
					"sts:ExternalId": "SpaceliftIntegration@*"
				}
			}
		}
	]
}
`

const inlinePolicy = `{
    "Version": "2012-10-17",
    "Statement": [
        {
            "Sid": "VizNowDeployInfra0",
            "Effect": "Allow",
            "Action": [
                "iam:*",
                "s3:*",
                "kms:*",
                "route53:*",
                "sts:*",
                "ec2:*",
                "tag:*",
                "logs:*"
            ],
            "Resource": "*"
        }
    ]
} 
`

const vizNowTabInlinePolicy = `{
  "Version": "2012-10-17",
  "Statement": [
    {
      "Sid": "VizNowManage0",
      "Effect": "Allow",
      "Action": [
        "iam:*",
        "kms:*",
        "route53:*",
        "servicequotas:*",
        "s3:*",
        "ec2:*",
        "tag:*",
        "sts:*",
        "logs:*"
      ],
      "Resource": "*"
    },
    {
      "Sid": "AllowSSMDocumentsForSendCommand",
      "Effect": "Allow",
      "Action": "ssm:SendCommand",
      "Resource": "arn:aws:ssm:*:*:document/*"
    },
    {
      "Sid": "AllowSendCommandToVizNowInstances",
      "Effect": "Allow",
      "Action": ["ssm:SendCommand"],
      "Resource": "arn:aws:ec2:*:*:instance/*",
      "Condition": {
        "StringEquals": {
          "ssm:ResourceTag/VizNow": "true"
        }
      }
    },
    {
      "Sid": "AllowCommandInvocationChecks",
      "Effect": "Allow",
      "Action": ["ssm:ListCommandInvocations", "ssm:GetCommandInvocation"],
      "Resource": "*"
    },
    {
      "Sid": "AllowSSMInventoryReadOnly",
      "Effect": "Allow",
      "Action": ["ssm:ListInventoryEntries", "ssm:DescribeInstanceInformation"],
      "Resource": "*",
      "Condition": {
        "StringEquals": {
          "ssm:ResourceTag/VizNow": "true"
        }
      }
    },
    {
      "Sid": "AllowCreateMediaConnectFlows",
      "Effect": "Allow",
      "Action": ["mediaconnect:CreateFlow"],
      "Resource": "*"
    },
    {
      "Sid": "AllowManageVizNowFlowsByName",
      "Effect": "Allow",
      "Action": [
        "mediaconnect:DeleteFlow",
        "mediaconnect:UpdateFlow",
        "mediaconnect:StartFlow",
        "mediaconnect:StopFlow",
        "mediaconnect:AddFlowOutputs",
        "mediaconnect:RemoveFlowOutput",
        "mediaconnect:UpdateFlowOutput",
        "mediaconnect:AddFlowSources",
        "mediaconnect:RemoveFlowSource",
        "mediaconnect:UpdateFlowSource",
        "mediaconnect:AddFlowVpcInterfaces",
        "mediaconnect:RemoveFlowVpcInterface",
        "mediaconnect:GrantFlowEntitlements",
        "mediaconnect:UpdateFlowEntitlement",
        "mediaconnect:DescribeFlow",
        "mediaconnect:ListEntitlements"
      ],
			"Resource": "arn:aws:mediaconnect:*:*:*VizNow-*"
    },
    {
      "Sid": "AllowListMediaConnectFlows",
      "Effect": "Allow",
      "Action": [
        "mediaconnect:ListFlows",
        "mediaconnect:DescribeFlow",
        "mediaconnect:ListTagsForResource"
      ],
      "Resource": "*"
    }
  ]
}
`

export default {
  vizNowTabInlinePolicy,
  trustPolicy,
  inlinePolicy
}
